import { BookMarkedIcon, ClipboardCheckIcon, ClipboardListIcon, GlobeIcon, PuzzleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '150 Attività di Geologia per la Classe',
    description: '150 attività pronte con obiettivo, durata, materiali semplici e sicuri, svolgimento passo per passo e soluzioni per il docente.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Raccolta di Verifiche di Geologia',
    description: 'Verifiche per ogni volume con scelta multipla, vero/falso, lettura di schemi e carte, semplici calcoli e domande aperte, con soluzioni e griglie di punteggio.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: '50 Progetti di Geologia e Sfide STEM',
    description: '50 progetti con modelli, simulazioni e ricerche sul territorio, con fasi, ruoli degli studenti e criteri di valutazione.',
    icon: PuzzleIcon,
  },
  {
    number: '4',
    title: 'Guida del Docente a Concetti e Terminologia della Geologia',
    description: 'I termini essenziali spiegati in modo chiaro, con esempio concreto ed errore comune da evitare.',
    icon: BookMarkedIcon,
  },
  {
    number: '5',
    title: '100 Casi di Studio di Geologia dal Mondo',
    description: "100 casi reali dall'Italia e dal mondo (Etna, Vesuvio, Alpi, Vajont, Larderello…) con domande di discussione per gli studenti.",
    icon: GlobeIcon,
  },
];
